let rickys = [
	'https://www.parati.com.ar/wp-content/uploads/2020/10/RICARDO-FORT-DESTACADA.jpg',
	'https://artear-tn-prod.cdn.arcpublishing.com/resizer/ra8C-tEtzI1-sj6MWf8A2zH-reU=/767x0/smart/arc-anglerfish-arc2-prod-artear.s3.amazonaws.com/public/5PE42LAXDTHIRIFOCFEJDHM7UA.jpg',
	'https://pbs.twimg.com/profile_images/914670966713847808/GOBh8OYt_400x400.jpg',
	'https://cdnvos.lavoz.com.ar/sites/default/files/styles/width_1072/public/nota_periodistica/RF1.jpg',
	'https://media.canalnet.tv/2020/12/Ricky-Fort.jpg'
]

let powerRangers = [
	'http://2.bp.blogspot.com/-yP8Br4GZ0gU/VTB7yhW4XtI/AAAAAAADWys/RfFff9P1oWc/s1600/Screenshot%2B(1539).png',
	'http://3.bp.blogspot.com/-uGWTxRV0zNA/VTB4kwEYLrI/AAAAAAADWwo/IMYtE1Z-__Q/s1600/Screenshot%2B(1542).png',
	'http://2.bp.blogspot.com/-8UDVvjLx398/VTB7zeXDbzI/AAAAAAADWyw/EdwdeYshElY/s1600/Screenshot%2B(1540).png',
	'http://2.bp.blogspot.com/-3OveayFHAcc/VTB77w6UI3I/AAAAAAADWy8/B9FjTauCShw/s1600/Screenshot%2B(1543).png',
	'http://1.bp.blogspot.com/-dkvhU-mWqYo/VTB8Rt_EH9I/AAAAAAADWzU/7l1Lcxanl-E/s1600/Screenshot%2B(1545).png'
]

export { rickys, powerRangers }